/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.927.96C.633 1.258.4 1.612.24 2.003a3.28 3.28 0 000 2.472c.16.391.392.745.686 1.042L5.527 10l4.599-4.487c.561-.615.874-1.43.874-2.276 0-.847-.313-1.661-.874-2.276A3.064 3.064 0 009.121.25a2.973 2.973 0 00-2.81.228 3.09 3.09 0 00-.578.483c-.035.035-.07.089-.103.142-.035.054-.07.107-.104.143-.034-.036-.07-.09-.104-.144A1.007 1.007 0 005.32.961 3.088 3.088 0 004.316.25a2.973 2.973 0 00-2.385 0A3.065 3.065 0 00.927.96zm7.732 1.36a1.063 1.063 0 00-.339-.238.973.973 0 00-1.056.177 3.446 3.446 0 01-.144.198c-.038.049-.09.11-.154.177l-1.43 1.483-1.44-1.473a2.391 2.391 0 01-.308-.386 1.05 1.05 0 00-.274-.176.973.973 0 00-.781 0 1.065 1.065 0 00-.349.248l-.018.02-.018.018a1.187 1.187 0 00-.254.388 1.28 1.28 0 000 .964c.059.146.143.274.245.379l3.187 3.107 3.152-3.075C8.88 3.895 9 3.577 9 3.237a1.38 1.38 0 00-.341-.917zM.35 7.15A9.76 9.76 0 000 9.75c0 5.385 4.365 9.75 9.75 9.75a9.717 9.717 0 006.772-2.735l2.327 1.994 3.5 3 1.302-1.518-3.5-3-2.34-2.005A9.704 9.704 0 0019.5 9.75c0-4.789-3.453-8.771-8.005-9.594.429.707.818 1.58.954 2.327A7.75 7.75 0 112.046 8.905L.35 7.15z"
      />
    </svg>
  );
});

IconComponent.displayName = 'IconSavedSearches24';

export const IconSavedSearches24: React.FC<ISVGIconProps> = createIcon(IconComponent);
